<template>
    <v-app>
        <v-app-bar
            v-if="!isLoading"
            app
            color="primary"
            dark
        >
            <v-app-bar-nav-icon
                @click.stop="drawer = !drawer"
                class="d-md-none"
            />
            <div
                class="d-flex align-center"
            >
                <v-img
                    alt="ASI Reisen Logo"
                    class="shrink mr-2"
                    contain
                    src="./assets/logo.svg"
                    transition="scale-transition"
                    height="60px"
                />
            </div>
            <v-tabs
                class="nav__links d-none d-md-flex"
            >
                <v-tab
                    :to="{name: 'Trips'}"
                    exact
                    v-role:admin
                >
                    {{ $t('menu.trips') }}
                </v-tab>
                <v-tab
                    :to="{name: 'Enquiries'}"
                    exact
                    v-role:operator
                >
                    {{ $t('menu.enquiries') }}
                </v-tab>
                <v-tab
                    :to="{name: 'Bookings'}"
                    exact
                    v-role:operator
                >
                    {{ $t('menu.bookings') }}
                </v-tab>
                <v-tab
                    :to="{name: 'TourbookRelease'}"
                    exact
                    v-role:view-tourbook
                >
                    {{ $t('menu.tourbook_release') }}
                </v-tab>
                <!-- TODO PHON-3338 Change rights once ready (v-role:supplier) -->
                <v-tab
                    :to="{name: 'Services'}"
                    exact
                    v-role:admin
                >
                    {{ $t('menu.services') }}
                </v-tab>
            </v-tabs>
            <v-spacer/>
            <span
                class="mr-4"
            >
                {{ user.companyName ? user.companyName : user.name }}
            </span>
            <v-menu>
                <template
                    v-slot:activator="{ on, attrs }"
                >
                    <v-btn
                        dark
                        text
                        v-on="on"
                        v-bind="attrs"
                        :title="$t('menu.changeLanguage')"
                    >
                        {{ $i18n.locale.toUpperCase() }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="locale in locales"
                        :key="locale"
                        @click="setLocale(locale)"
                        :class="locale === $i18n.locale ? 'v-list-item--active' : ''"
                    >
                        {{ locale.toUpperCase() }}
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-menu
                bottom
                left
                v-if="isLoggedIn"
            >
                <template
                    v-slot:activator="{on, attrs}"
                >
                    <v-btn
                        dark
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>
                            mdi-dots-vertical
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        link
                        :to="{name: 'Profile'}"
                        v-can:view-profile
                    >
                        <v-list-item-title>
                            Profile
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        link
                        :to="{name: 'Contact'}"
                    >
                        <v-list-item-title>
                            {{ $t('menu.contact') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        link
                        @click="logout"
                    >
                        <v-list-item-title>
                            Logout
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer
            v-if="!isLoading"
            v-model="drawer"
            app
        >
            <v-list
                nav dense
            >
                <v-list-item
                    :to="{name: 'Trips'}"
                    exact
                    v-role:admin
                >
                    {{ $t('menu.trips') }}
                </v-list-item>
                <v-list-item
                    :to="{name: 'Enquiries'}"
                    exact
                    v-role:operator
                >
                    {{ $t('menu.enquiries') }}
                </v-list-item>
                <v-list-item
                    :to="{name: 'Bookings'}"
                    exact
                    v-role:operator
                >
                    {{ $t('menu.bookings') }}
                </v-list-item>
                <v-list-item
                    :to="{name: 'TourbookRelease'}"
                    exact
                    v-role:is-logged-in
                >
                    {{ $t('menu.tourbook_release') }}
                </v-list-item>
                <!-- TODO PHON-3338 Change rights once ready (v-role:supplier) -->
                <v-list-item
                    :to="{name: 'Services'}"
                    exact
                    v-role:admin
                >
                    {{ $t('menu.services') }}
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-main
            v-if="!isLoading"
        >
            <router-view/>
        </v-main>
        <v-snackbar
            v-model="snackbarActive"
            :color="snackbarType"
        >
            <span>
                {{ snackbarData }}
            </span>
        </v-snackbar>
        <v-app-bar
            v-if="isLoading"
            app
            color="primary"
            dark
        >
            <div
                class="d-flex align-center"
            >
                <v-img
                    alt="ASI Reisen Logo"
                    class="shrink mr-2"
                    contain
                    src="./assets/logo.svg"
                    transition="scale-transition"
                    height="60px"
                />
            </div>
        </v-app-bar>
        <v-container
            v-if="isLoading"
            style="height: 400px;"
        >
            <v-row
                class="fill-height"
                align-content="center"
                justify="center"
            >
                <v-col
                    class="text-subtitle-1 text-center"
                    cols="12"
                >
                    Loading Tripmate
                </v-col>
                <v-col
                    cols="6"
                >
                    <v-progress-linear
                        color="primary"
                        indeterminate
                        rounded
                        height="6"
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {AuthAction} from "./store/auth/types";
    import {SnackBarAction} from "./store/snackbar/types";
    import {setCurrentLocale} from "@/utils/locale";

    export default {
        name: 'App',

        components: {},

        data: () => ({
            drawer: false,
            locales: [
                'en',
                'de',
            ],
        }),
        methods: {
            ...mapActions({
                logoutUser: `auth/${AuthAction.LOGOUT}`,
                setSnackbar: `snackbar/${SnackBarAction.SET}`,
                setSnackbarActive: `snackbar/${SnackBarAction.SET_ACTIVE}`,
            }),
            logout: function () {
                this.logoutUser();
                this.$router.push('/login');
            },
            setLocale: function(locale) {
                setCurrentLocale(locale, this.$i18n);
            },
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
                isLoading: 'auth/isLoading',
                isLoggedIn: 'auth/isLoggedIn',
                isSnackbarActive: 'snackbar/active',
                snackbarData: 'snackbar/data',
                snackbarType: 'snackbar/type',
            }),
            snackbarActive: {
                get: function() {
                    return this.isSnackbarActive;
                },
                set: function(value) {
                    this.setSnackbarActive(value);
                }
            },
        }
    };
</script>

<style lang="scss">
    @import "~vuetify/src/styles/main";

    .nav__links {
        margin-left: 12%;

        > a {
            color: white !important;
            margin-right: 16px;
            text-decoration: none;
        }
    }
</style>
